// GENERAL LAYOUT FOR GLOBAL FOOTER
import './footer.scss';

import LogoEcoFooter from '../../../assets/logo-ecoescuela.png';
import LogoCambFooter from '../../../assets/logo_cambridge.png';
import LogoCertiportFooter from '../../../assets/certiport.png';
import LogoCiscoFooter from '../../../assets/cisco.png';
import LogoMOS2003Footer from '../../../assets/MOS-2003.png';
import LogoDelf from '../../../assets/delflogo.jpg';
import LogoIb from '../../../assets/ibo_org_2_.png';
import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import legalConfig from '../../Pages/Legal/legalConfig';

const Footer = () => {
  return (
    <div className="row footer">
      <div className="col-12">
        <div className="footer-wrapper">
          <div className="row footer-inner">
            <div className="col-lg-7 col-md-7 col-sm-12">
              <div className="row info">
                <div className="sub-info-inner">
                  <div className="sub-info-1">
                    <h6 className="address">SECUNDARIA BABEQUE</h6>
                    <p className="address-2">Av. Roberto Pastoriza</p>
                    <p className="address-2">#329, Naco, DN</p>
                    <p className="address-2">{legalConfig.phone}</p>
                  </div>

                  <div className="sub-info-2">
                    <Link to="/contactanos">
                      <p className="links">CONTÁCTANOS</p>
                    </Link>
                    <a href="https://forms.office.com/r/MSgALxkh0H" target="_blank" rel="noreferrer">
                      <p className="links">TRABAJA CON NOSOTROS</p>
                    </a>
                    <Link to="/politica-de-privacidad">
                      <p className="links">POLÍTICA DE PRIVACIDAD</p>
                    </Link>
                  {/* <Link to="/eliminacion-de-datos">
                      <p className="links">ELIMINACIÓN DE DATOS</p>
                    </Link>*/}  
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-md-5 col-sm-12 footer-icons">
              <div className="logo-ib-footer">
                <a target="_blank" rel="noreferrer" href="https://www.ibo.org/es/">
                  <Image src={LogoIb} alt="Organización del Bachillerato Internacional" />
                </a>
              </div>
              <div className="logo-ib-footer">
                <Image src={LogoCambFooter} alt="Cambridge" />
              </div>
              <div className="logo-ib-footer">
                <Image src={LogoEcoFooter} alt="Ecoescuela" />
              </div>
              <div className="logo-ib-footer">
                <Image src={LogoCiscoFooter} alt="Cisco Networking Academy" />
              </div>
              <div className="logo-ib-footer">
                <Image src={LogoDelf} alt="Certificación DELF" />
              </div>
              <div className="logo-ib-footer">
                <Image src={LogoMOS2003Footer} alt="Microsoft Office Specialist" />
              </div>
              <div className="logo-ib-footer">
                <Image src={LogoCertiportFooter} alt="Certiport" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
